import React, { Component } from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import { lighten, makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import Snackbar from "@material-ui/core/Snackbar";
import TextField from "@material-ui/core/TextField";
import Paper from "@material-ui/core/Paper";
import PersonAddIcon from "@material-ui/icons/PersonAdd";
import VisibilityIcon from "@material-ui/icons/Visibility";
import {
  DeleteBusiness,
  SetBusinessPermission,
  searchBusinesses,
  GetBusinesses,
  filterbyuseragent,
  DeleteUser,
  GetUsers,
  IsAuthorized,
  SetUserPermission,
  SearchUser,
  SearchUserPhone,
} from "../../fetchs";
import { Link } from "react-router-dom";
import { Button, Grid } from "@material-ui/core";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import AlertDialog from "../Prompt/alert-dialog.component";
import CircularProgress from "@material-ui/core/CircularProgress";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import LockOpenIcon from "@material-ui/icons/LockOpen";

import Switch from "@material-ui/core/Switch";

import { ModalDetailorder, ModalDetailorder1 } from "../Useful/Useful";

import "./user-list.styles.css";
// import Checkbox from '@material-ui/core/Checkbox';
// import IconButton from '@material-ui/core/IconButton';
// import Tooltip from '@material-ui/core/Tooltip';
// import FormControlLabel from '@material-ui/core/FormControlLabel';
// import FilterListIcon from '@material-ui/icons/FilterList';

const headCells = [
  { id: "index", numeric: false, disablePadding: true, label: "ردیف" },
  { id: "index", numeric: false, disablePadding: true, label: "عکس" },
  { id: "name", numeric: false, disablePadding: true, label: "نام" },
  { id: "phone", numeric: true, disablePadding: false, label: "شماره تماس" },
  { id: "phone", numeric: true, disablePadding: false, label: "دسته بندی شغل" },
  {
    id: "phone",
    numeric: true,
    disablePadding: false,
    label: "نمایش روی نقشه",
  },

  {
    id: "userType",
    numeric: true,
    disablePadding: false,
    label: "اطلاعات پرداخت",
  },
  {
    id: "userType",
    numeric: true,
    disablePadding: false,
    label: "اطلاعات بیشتر",
  },
  {
    id: "userType",
    numeric: true,
    disablePadding: false,
    label: "اجازه دسترسی",
  },
];

const EnhancedTableHead = () => {
  //const { classes } = props;

  return (
    <TableHead>
      <TableRow>
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            align={"center"}
            padding={headCell.disablePadding ? "none" : "default"}
          >
            <TableSortLabel active={false}>{headCell.label}</TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
};

EnhancedTableHead.propTypes = {
  classes: PropTypes.object.isRequired,
};

const useToolbarStyles = makeStyles((theme) => ({
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
  },
  highlight:
    theme.palette.type === "light"
      ? {
          color: theme.palette.secondary.main,
          backgroundColor: lighten(theme.palette.secondary.light, 0.85),
        }
      : {
          color: theme.palette.text.primary,
          backgroundColor: theme.palette.secondary.dark,
        },
  spacer: {
    flex: "1 1 100%",
  },
  actions: {
    color: theme.palette.text.secondary,
    width: "470px",
  },
  title: {
    flex: "0 0 auto",
  },
  formControl: {
    width: "150px",
  },
  link: {
    margin: "10px",
    lineHeight: "4",
  },
}));

const EnhancedTableToolbar = (props) => {
  const classes = useToolbarStyles();
  const { numSelected } = props;

  return (
    <Toolbar
      className={clsx(classes.root, {
        [classes.highlight]: numSelected > 0,
      })}
    >
      <Grid item xs={8}>
        {
          <Typography variant="h6" id="tableTitle">
            لیست مشاغل
          </Typography>
        }
      </Grid>
      <Grid item xs={4}>
        <Link to="/main/addbusiness" className={classes.link}>
          <Button variant="contained" color="primary">
            ساخت شغل جدید
          </Button>
        </Link>
      </Grid>
    </Toolbar>
  );
};

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
};

export default class UserList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      name: "",
      phone: "",
      page: 0,
      rowsPerPage: 20,
      rowsLength: 0,
      rows: [],
      alertDialog: false,
      deleteId: null,
      loading: false,
      openSnackbar: false,
      errorMessage: "",
      flag: false,
      render: false,
    };
  }

  handleCloseSnackbar = () => {
    this.setState({ openSnackbar: false });
  };

  componentDidMount() {
    this.getUsersFromServer();
  }

  getUsersFromServer = () => {
    if (this.state.name.length > 0) {
      this.setState({ loading: true });
      searchBusinesses(this.state.name, this.state.page, this.state.rowsPerPage)
        .then((response) => {
          this.setState({ loading: false });
          return response.json();
        })
        .then((responseJson) => {
          if (responseJson.Message)
            this.setState({
              errorMessage: responseJson.Message,
              openSnackbar: true,
            });
          else
            this.setState({
              rows: responseJson.queryResult,
              rowsLength: responseJson.count,
            });
        })
        .catch((error) => {
          this.setState({
            loading: false,
            errorMessage: error.Message,
            openSnackbar: true,
          });
          console.log(error);
        });
    } else {
      this.setState({ loading: true });
      GetBusinesses(this.state.page, this.state.rowsPerPage)
        .then((response) => {
          this.setState({ loading: false });
          return response.json();
        })
        .then((responseJson) => {
          if (responseJson.Message)
            this.setState({
              errorMessage: responseJson.Message,
              openSnackbar: true,
            });
          else
            this.setState({
              rows: responseJson.queryResult,
              rowsLength: responseJson.count,
            });
        })
        .catch((error) => {
          this.setState({
            loading: false,
            errorMessage: error.Message,
            openSnackbar: true,
          });
          console.log(error);
        });
    }
  };
  filterusers = () => {
    this.setState({ loading: true });
    filterbyuseragent(this.state.page, this.state.rowsPerPage)
      .then((response) => {
        this.setState({ loading: false });
        return response.json();
      })
      .then((responseJson) => {
        if (responseJson.Message)
          this.setState({
            errorMessage: responseJson.Message,
            openSnackbar: true,
          });
        else
          this.setState({
            rows: responseJson.data,
            rowsLength: responseJson.count,
          });
      })
      .catch((error) => {
        this.setState({
          loading: false,
          errorMessage: error.Message,
          openSnackbar: true,
        });
        console.log(error);
      });
  };

  handleChangePage = (event, newPage) => {
    this.setState({ page: newPage }, () => {
      this.getUsersFromServer();
    });
  };

  handleChangeRowsPerPage = (event) => {
    this.setState({ rowsPerPage: +event.target.value, page: 0 }, () => {
      this.getUsersFromServer();
    });
  };

  handleDelete = () => {
    this.setState({ alertDialog: false, loading: true });
    DeleteBusiness(this.state.deleteId)
      .then((response) => {
        this.setState({ loading: false });
        if (response.status === 200) {
          toast.success("شغل  با موفقیت حذف  شد");
        }

        this.getUsersFromServer();

        return response.json();
      })
      .then((responseJson) => {
        // if (responseJson.Message)
        //   this.setState({
        //     errorMessage: responseJson.Message,
        //     openSnackbar: true,
        //   });
      })
      .catch((error) => {
        // this.setState({
        //   loading: false,
        //   errorMessage: error.message,
        //   openSnackbar: true,
        // });
        // console.log(error);
      });
  };

  handlePrepareDelete = (id) => {
    this.setState({ deleteId: id, alertDialog: true });
  };

  handleCloseDialog = () => {
    this.setState({ alertDialog: false });
  };

  emptyRows = () =>
    this.state.rowsPerPage -
    Math.min(
      this.state.rowsPerPage,
      this.state.rowsLength - this.state.page * this.state.rowsPerPage
    );

  handleChange = (name) => (event) => {
    SetBusinessPermission(event.target.value)
      .then((response) => {
        if (response.status !== 200) {
          toast.error("خطای تایید شغل");
        } else if (response.status === 200) {
          toast.success("عملیات با موفقیت انجام شد");
        }

        return response.json();
      })
      .then((responseJson) => {
        // const idx = this.state.rows.findIndex(
        //   (rows) => rows.id === responseJson.id
        // );
        // this.state.rows.splice(idx, 1, responseJson);
        this.getUsersFromServer();
        this.setState(!this.state.render);
      })
      .catch((error) => {
        // setloading(false);
        console.log(error);
      });
  };

  render() {
    const { classes } = this.props;
    return (
      <div className="root">
        <Paper className="paper">
          <EnhancedTableToolbar
            visitor={this.state.visitor}
            numSelected={0}
            handleChange={this.handleChange}
            userType={this.state.userType}
          />
          <div className="tableWrapper">
            <Grid item xs={12} sm={4}>
              <TextField
                placeholder="نام کاربر را وارد کنید..."
                onChange={(e) => this.setState({ name: e.target.value })}
                id="name"
                label="نام"
                value={this.state.name}
              />
              <Button
                onClick={() => this.getUsersFromServer()}
                margin="normal"
                variant="contained"
                color="primary"
              >
                جستجو
              </Button>
            </Grid>
            <Grid item xs={12} sm={4}>
              {/* <TextField
                placeholder=" شماره تماس را وارد کنید..."
                onChange={(e) => this.setState({ phone: e.target.value })}
                id="phone"
                label="شماره تماس"
                value={this.state.phone}
              /> */}
              {/* <Button
                onClick={() => this.getUsersFromServer()}
                margin="normal"
                variant="contained"
                color="primary"
              >
                جستجو
              </Button> */}
            </Grid>
            {/* <Button
              onClick={() => this.filterusers()}
              margin="normal"
              variant="contained"
              color="primary"
            >
              فیلتر بر اساس نماینده فروش
            </Button> */}
            {/* <Grid item xs={12} sm={4}>
              <Button variant='contained' color='primary'>
                جستجو
              </Button>
            </Grid> */}
            <Table
              className="table"
              aria-labelledby="tableTitle"
              size={"medium"}
            >
              <EnhancedTableHead
                classes={classes}
                numSelected={0}
                rowCount={this.state.rowsLength}
              />
              <TableBody>
                {this.state.rows &&
                  this.state.rows.map((row, index) => {
                    return (
                      <TableRow hover tabIndex={-1} key={row.id}>
                        <TableCell align="center">
                          {this.state.page * this.state.rowsPerPage + index + 1}
                        </TableCell>
                        <TableCell align="center">
                          <img
                            src={`http://test.asa-oil.ir/${row.imgUrl}`}
                            alt={row.name}
                            style={{ maxHeight: "50px", maxWidth: "50px" }}
                          />
                        </TableCell>
                        <TableCell align="center">{row.name}</TableCell>
                        <TableCell align="center">{row.mobile}</TableCell>
                        <TableCell align="center">
                          {row.businessCategoryName}
                        </TableCell>
                        <TableCell align="center">
                          <Link to={`/main/showmap/${row.id}`}>
                            <VisibilityIcon />
                          </Link>
                        </TableCell>

                        <TableCell align="center">
                          <ModalDetailorder1
                            buttonLabel="اطلاعات پرداخت "
                            title="اطلاعات پرداخت"
                            amount={
                              row.pay && row.pay.amount
                                ? row.pay.amount
                                : "هزینه ثبت نشده است"
                            }
                            isSucess={
                              row.pay && row.pay.isSucess
                                ? row.pay.isSucess
                                : "پرداخت ثبت نشده است"
                            }
                            systemTraceNo={
                              row.pay && row.pay.systemTraceNo
                                ? row.pay.systemTraceNo
                                : "کد پیگیری  ثبت نشده است"
                            }
                            retrivalRefNo={
                              row.pay && row.pay.retrivalRefNo
                                ? row.pay.retrivalRefNo
                                : "کد پرداخت ثبت نشده است"
                            }
                            payDateTime={
                              row.pay &&
                              row.pay.payDateTime &&
                              row.pay.payDateTime
                            }
                          ></ModalDetailorder1>
                        </TableCell>

                        <TableCell align="center">
                          <ModalDetailorder
                            buttonLabel="اطلاعات بیشتر "
                            title="اطلاعات بیشتر"
                            desc={row.desc ? row.desc : "توضیحات ثبت نشده است"}
                            address={
                              row.address ? row.address : "آدرس ثبت نشده است"
                            }
                            tell={
                              row.tell ? row.tell : "تلفن ثابت ثبت نشده است"
                            }
                            insta={
                              row.insta ? row.insta : "اینستاگرام ثبت نشده است"
                            }
                            website={
                              row.website ? row.website : "وب سایت ثبت نشده است"
                            }
                            whatsapp={
                              row.whatsapp
                                ? row.whatsapp
                                : "واتزاپ  ثبت نشده است"
                            }
                            telegram={
                              row.telegram
                                ? row.telegram
                                : "تلگرام  ثبت نشده است"
                            }
                            createDatetime={
                              row.createDatetime
                                ? row.createDatetime
                                : "تاریخ ثبت ذخیره نشده"
                            }
                            // onlinePayCode={
                            //   row.onlinePayCode
                            //     ? row.onlinePayCode
                            //     : " کد پرداخت ثبت نشده است"
                            // }
                            // payType={
                            //   row.payType == 1 ? "آنلاین" : "غیر آنلاین    "
                            // }
                          ></ModalDetailorder>
                        </TableCell>
                        <TableCell align="center">
                          <Switch
                            color="primary"
                            checked={row.isConfirm}
                            onChange={this.handleChange("permission")}
                            name="isConfirmed"
                            value={row.id}
                            inputProps={{
                              "aria-label": "primary  checkbox",
                            }}
                          />
                        </TableCell>
                        {/* <TableCell align="center">
                          <Link to={`/main/editpass/${row.id}`}>
                            <LockOpenIcon color="primary" />
                          </Link>
                        </TableCell> */}
                        {/* <TableCell align="center">
                          <Link to={`/main/sellagent/${row.id}&`}>
                            <PersonAddIcon color="primary" />
                          </Link>
                        </TableCell> */}
                        <TableCell align="center">
                          <Link to={`/main/addbusiness/${row.id}`}>
                            <EditIcon color="primary" />
                          </Link>
                          <DeleteIcon
                            className="deleteIcon"
                            onClick={() => this.handlePrepareDelete(row.id)}
                          />
                        </TableCell>
                      </TableRow>
                    );
                  })}
                {this.emptyRows > 0 && (
                  <TableRow style={{ height: 49 * this.emptyRows }}>
                    <TableCell colSpan={6} />
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </div>
          {this.state.loading && (
            <CircularProgress size={24} className="buttonProgress" />
          )}
          <TablePagination
            rowsPerPageOptions={[20, 50, 100]}
            component="div"
            count={this.state.rowsLength}
            rowsPerPage={this.state.rowsPerPage}
            page={this.state.page}
            backIconButtonProps={{
              "aria-label": "previous page",
            }}
            nextIconButtonProps={{
              "aria-label": "next page",
            }}
            onChangePage={this.handleChangePage}
            onChangeRowsPerPage={this.handleChangeRowsPerPage}
          />
        </Paper>
        <AlertDialog
          open={this.state.alertDialog}
          title={`اخطار`}
          body={`آیا از حذف کاربر اطمینان دارید؟`}
          handleYes={this.handleDelete}
          handleNo={this.handleCloseDialog}
        />
        <Snackbar
          anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
          autoHideDuration={3000}
          open={this.state.openSnackbar}
          ContentProps={{
            "aria-describedby": "message-id",
            class:
              "error MuiTypography-root MuiPaper-root MuiPaper-elevation6 MuiSnackbarContent-root MuiTypography-body2",
          }}
          message={<span id="message-id"> {this.state.errorMessage} </span>}
          onClose={() => this.handleCloseSnackbar(false)}
        />
      </div>
    );
  }
}
